<template>
  <div
    v-if="processedLink"
    class="aiden-helper"
  >
    <h3 class="aiden-helper__title heading heading--4">
      {{ title }}
    </h3>
    <div class="aiden-helper__content">
      <span class="aiden-helper__subtitle">
        {{ subtitle }}
      </span>
      <appLink
        :to="processedLink"
        class="aiden-helper__button button button--cta button--full button"
      >
        <span>{{ buttonText }}</span>
        <IconCssArrow2 class="icon icon--arrow icon--arrow-right" />
      </appLink>
    </div>
  </div>
</template>

<script setup>
const { locale } = useI18n()
const props = defineProps({
  title: {
    type: String,
    default: 'Need help?',
  },
  subtitle: {
    type: String,
    default: 'Find out quickly and easily which product is right for you here.',
  },
  buttonLink: {
    type: String,
    default: null,
  },
  buttonText: {
    type: String,
    default: 'Help me choose',
  },
})

const processedLink = computed(() => {
  if (!props.buttonLink) return null

  const colonIndex = props.buttonLink.indexOf(':')
  if (props.buttonLink.indexOf(':') === -1) return null

  const [lang, restPath] = [
    props.buttonLink.substring(0, colonIndex),
    props.buttonLink.substring(colonIndex + 1),
  ]

  const isMatchingLocale = lang.toLowerCase() === locale.value.toLowerCase()
  return isMatchingLocale ? `aiden-advisor-id:${restPath}` : null
})
</script>

<style>
  @import url("~layers/app/components/Product/Aiden.css");
</style>
